// extracted by mini-css-extract-plugin
module.exports = {"Container":"PlayerModal_Container__2Kp0U","VideoWrapper":"PlayerModal_VideoWrapper__3ZGy2"};